<template>
    <rkm-modal
        extra-large
        ref="Modal"
        title="Cadastro de solicitante"
    >
        <Form
            :data="data"
            :original-solicitante="originalSolicitante"
            :solicitante="solicitante"
            @save="close"
            ref="Form"
        />

        <template v-slot:footer="{ cancel }">
            <rkm-button
                :disabled="!!loading"
                @click="cancel"
            >
                Cancelar
            </rkm-button>

            <rkm-button
                :disabled="!!loading"
                @click="$refs.Form.save()"
                color="primary"
            >
                {{ solicitante ? 'Salvar' : 'Incluir' }}
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Components.
import Form from './Form'

// Mixins.
import { object } from '@/mixins'

// Vuex.
import { mapGetters } from 'vuex'

export default {
    components: { Form },
    computed: {
        ...mapGetters({ loading: 'getLoading' }),
    },
    data: () => ({
        originalSolicitante: null,
        solicitante: null,
    }),
    methods: {
        open(solicitante = null) {

            this.resetForm()

            this.originalSolicitante = solicitante
            this.solicitante = this.clone(solicitante)

            this.$refs.Modal.show()
        },
        close() {

            this.$refs.Modal.hide()
        },
        resetForm() {

            this.data.form.infraestruturas = []
        },
    },
    mixins: [object],
    props: {
        data: { type: Object, required: true },
    }
}
</script>